import { Input } from '@codes/ui-kit/components/ui/input';

import { maskApiKey } from '../utils';

interface MaskedKeyDisplayProps {
    value: string;
    label?: string;
    className?: string;
}

export const MaskedKeyDisplay = ({ value, label = 'API Key', className }: MaskedKeyDisplayProps) => {
    const displayValue = maskApiKey(value);

    return (
        <div className={className}>
            {label && <label className="text-sm font-medium text-muted-foreground block mb-2">{label}</label>}
            <Input value={displayValue} readOnly className="flex-1 font-mono text-sm" aria-label={label} />
        </div>
    );
};
